<template>
  <div class="font-sans antialiased tw-w-full" id="app">
    <nav
      class="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-mx-auto tw-p-6"
    >
      <div
        class="tw-flex tw-items-center tw-flex-no-shrink tw-text-white tw-mr-6"
      >
        <router-link to="/">
          <div
            class="tw-flex tw-items-center tw-flex-no-shrink tw-text-black tw-mr-6"
          >
            <img
              class="tw-inline tw-m-1"
              src="https://res.cloudinary.com/dldd8ucby/image/upload/v1587167979/RA/WhatsApp_Image_2020-04-16_at_10.51.15_AM.jpg"
            />
            <span
              class="tw-font-semibold tw-text-lg tw-text-black md:tw-px-4 md:tw-py-2 lg:tw-mt-0 tw-mr-4"
              >G1BRA
            </span>
          </div>
        </router-link>
      </div>
      <div class="tw-text-center tw-mx-auto md:tw-mx-0">
        <p>
          Mission Quiz 2026
        </p>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      open: false,
      user: {},
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("ra-user"));
    if (!this.user) {
      this.$router.push("/login");
    }
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style scoped>
.v-application a {
  text-decoration: none;
  color: white;
}

img {
  width: 75px;
  height: 75px;
}
</style>
